import { apiGet } from '@/lib/api';

/**
 * ZUŻYCIE DANYCH PRZEZ AGENTÓW — odczyt dla zakładki w „Logi i statystyki".
 *
 * ⚠️ LICZBA JEST MIERZONA NA INSTANCJI, nie u agenta: bajty gniazda na każdym żądaniu kanału
 * agenta, czyli RAZEM Z NAGŁÓWKAMI. To istotne, bo przy naszych paczkach nagłówki są ruchem —
 * odpowiedź „nie ma zadań" to 14 bajtów treści i 363 bajty nagłówków. Poza pomiarem zostaje
 * narzut TLS i TCP/IP (~10–15%), bo TLS kończy się na brzegu platformy; ekran mówi o tym wprost.
 */
export type RuchWezla = {
  nodeId: string;
  nazwa: string | null;
  bytesIn: number;
  bytesOut: number;
  requests: number;
};

export type RuchRodzaj = { kind: string; bytesIn: number; bytesOut: number; requests: number };

export type PrzegladRuchu = {
  dni: number;
  dniPrzechowywania: number;
  limitMbNaDobe: number;
  suma: { bytesIn: number; bytesOut: number; requests: number };
  wezly: RuchWezla[];
  rodzaje: RuchRodzaj[];
  godziny: { hour: string; bytesIn: number; bytesOut: number }[];
};

export function fetchRuchAgenta(groupId: string, dni: number): Promise<PrzegladRuchu> {
  return apiGet<PrzegladRuchu>(`/ruch-agenta?groupId=${groupId}&dni=${dni}`);
}

/** Bajty na czytelną jednostkę. Trzy cyfry znaczące — „1,2 GB" mówi więcej niż „1234567890 B". */
export function bajty(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
